<template>
<div class="info-wrapper" id="block_display_info">
   <div class="info-div">
      <span class="info-label block-input-label">Total Runtime: </span>
      <span class="runtime"><span>{{durHour}}</span>:<span>{{durMinute}}</span>:<span>{{durSecond}}</span></span>
   </div>

   <!-- Recurrence isn't in use for now -->
   <!-- <div class="info-div">
      <span class="info-label block-input-label">Recurrence: </span>
      <span class="info-text recurrence">{{recurrence ? 'Yes' : 'No'}}</span>
   </div> -->

   <div class="info-div">
      <span class="info-label block-input-label">Create Date: </span>
      <span class="info-text recurrence">{{convertCreateDate}}</span>
   </div>

   <!-- <div class="info-div">
      <span class="info-label block-input-label">Expiration: </span>
      <span class="info-text recurrence">{{convertExpDate}}</span>
   </div> -->

</div>
</template>

<script>
export default {
   data() {
      return {
         durHour: 0,
         durMinute: 0,
         durSecond: 0
      }
   },

   props: ['recurrence', 'runtime', 'creation', 'expiration'],

   created() {
      this.convertRuntime();
   },
   
   computed: {
      convertCreateDate() {
         if (this.creation != '') {
            let createDate = new Date(this.creation);
            return createDate.toLocaleDateString();
         } else {
            return '';
         }
      },

      convertExpDate() {
         if (this.expiration != '') {
            let expDate = new Date(this.expiration);
            return expDate.toLocaleDateString();
         } else {
            return 'None';
         }
      }
   },

   methods: {
      convertRuntime() {
         let time = this.runtime;
         let hours = Math.floor(time / 3600);
         time = time - hours * 3600;
         let minutes = Math.floor(time / 60);
         let seconds = time - minutes * 60;

         if (hours <= 9) {
            hours = "0" + hours;
         }
         this.durHour = hours;
         
         if (minutes <= 9) {
            minutes = "0" + minutes;
         }
         this.durMinute = minutes;

         if (seconds <= 9) {
            seconds = "0" + seconds;
         }
         this.durSecond = seconds;
      },

   },

   watch: {
      runtime() {
         this.convertRuntime();
      }
   }
}
</script>


<style lang="scss" scoped>
.info-wrapper {
   font-size: 12px;
   display: flex;
   justify-content: space-between;
}

.info-div:not(:last-child) {
   margin-right: 20px;
}

.block-input-label {
   text-transform: uppercase;
   color: $gray-text;
}
</style>
